module.exports = __webpack_public_path__ + "static/img/税务筹划_优税宝.c6657f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/税务筹划_优税宝.jpg
// module id = J4Zq
// module chunks = 1